import { ATLAS_REQUEST, LOADING, SUCCESS, NOT_ASKED, FAILURE } from './constants';

/**
 * Kicks off the saga atlas call to get account restriction data
 * **/

export function atlasRequest(apexAccountId) {
  return {
    type: ATLAS_REQUEST,
    apexAccountId,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store params.
 */
export function loading(transferId) {
  return {
    type: LOADING,
    transferId,
  };
}

export function success(result) {
  return {
    type: SUCCESS,
    result,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/services/atlasRequest/actions.js